import React, { useState } from 'react';
import PromptInputBar from './PromptInputBar';

function BuilderPromptScreen({ experience, onSubmitPrompt, onBack }) {
  const [prompt, setPrompt] = useState('');

  const handleSubmit = () => {
    if (prompt.trim()) {
      onSubmitPrompt(prompt);
    }
  };

  return (
    <div className="builder-prompt-screen">
      {/* Background Grid Effect */}
      <div className="builder-bg-grid" />
      
      {/* Main Content Container */}
      <div className="builder-prompt-container">
        {/* Heading Section - Figma structure */}
        <div className="builder-heading">
          <div className="builder-heading-titles">
            <h1 className="builder-title">
              Build Web Experiences From Your Prompt
            </h1>
            <h2 className="builder-title-gradient">
              With 3D Built In
            </h2>
          </div>
          <p className="builder-subtitle">
            Describe the webpage or component you want to generate…
          </p>
        </div>

        {/* Shared Prompt Input Bar */}
        <PromptInputBar
          value={prompt}
          onChange={setPrompt}
          onSubmit={handleSubmit}
          experienceId={experience?.id || '24856'}
          placeholder="Type a message..."
        />
      </div>
    </div>
  );
}

export default BuilderPromptScreen;
